// import React, { useState, useRef, useEffect, useMemo } from "react";
// import DropDownIcon from "../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
// import Colors from "../../Constants/Colors";

// export default function DropdownWithPagination({
//   width,
//   label,
//   selected = [],       
//   setSelected,
//   options = [],
//   customWidth,
//   customTop,
//   isRequired,
//   style,
//   className,
//   isDisabled = false,
//   itemsPerPage = 5,
//   onSearchInputChange,
//   showSelectAll = false,
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [selectedLabel, setSelectedLabel] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState("");
//   const dropdownRef = useRef(null);
//   const searchInputRef = useRef(null);

//   // normalize selected array
//   const safeSelected = Array.isArray(selected) ? selected : [];

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // Build a comma label of selected items (optional UI)
//   // useEffect(() => {
//   //   if (safeSelected.length > 0 && Array.isArray(options)) {
//   //     const labels = options
//   //       .filter((o) => safeSelected.includes(o.id))
//   //       .map((o) => o.label);
//   //     setSelectedLabel(labels.join(", "));
//   //   } else {
//   //     setSelectedLabel("");
//   //   }
//   // }, [safeSelected, options]);


//   useEffect(() => {
//     if (safeSelected.length > 0 && Array.isArray(options)) {
//       const labels = options
//         .filter((o) => safeSelected.includes(o.id))
//         .map((o) => o.label);

//       const fullText = labels.join(", ");
//       const maxLength = 75; 

//       if (fullText.length > maxLength) {
//         setSelectedLabel(fullText.slice(0, maxLength) + "...");
//       } else {
//         setSelectedLabel(fullText);
//       }
//     } else {
//       setSelectedLabel("");
//     }
//   }, [safeSelected, options]);


//   // client-side filtering
//   // const filteredOptions = useMemo(() => {
//   //   if (!Array.isArray(options)) return [];
//   //   if (!searchTerm) return options;
//   //   const q = searchTerm.toLowerCase();
//   //   return options.filter((option) =>
//   //     (option.label || "").toString().toLowerCase().includes(q)
//   //   );
//   // }, [options, searchTerm]);

//   // client-side filtering (only if no server-side search handler)
//   const filteredOptions = useMemo(() => {
//     if (!Array.isArray(options)) return [];
//     // If onSearchInputChange is provided, assume server-side filtering
//     if (onSearchInputChange) return options;
//     // Otherwise, do client-side filtering
//     if (!searchTerm) return options;
//     const q = searchTerm.toLowerCase();
//     return options.filter((option) =>
//       (option.label || "").toString().toLowerCase().includes(q)
//     );
//   }, [options, searchTerm, onSearchInputChange]);

//   const totalPages = Math.max(1, Math.ceil(filteredOptions.length / itemsPerPage));
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;
//   const currentOptions = filteredOptions.slice(startIndex, endIndex);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [searchTerm]);

//   // toggle single option in the selected array
//   const handleToggleOption = (option) => {
//     if (isDisabled) return;
//     const id = option.id;
//     if (safeSelected.includes(id)) {
//       setSelected(safeSelected.filter((sid) => sid !== id));
//     } else {
//       setSelected([...safeSelected, id]);
//     }
//   };

//   // Select All / Unselect All logic (operates on full `options` list client-side)
//   const allOptionIds = useMemo(() => (Array.isArray(options) ? options.map((o) => o.id) : []), [options]);
//   const isAllSelected = allOptionIds.length > 0 && allOptionIds.every((id) => safeSelected.includes(id));

//   const handleSelectAll = () => {
//     if (isDisabled) return;
//     if (isAllSelected) {
//       // unselect all
//       setSelected([]);
//     } else {
//       // select all (based on all options currently provided)
//       setSelected(allOptionIds);
//     }
//   };

//   const handleClick = (option) => {
//     // kept name to match your original; now toggles in multi-select
//     handleToggleOption(option);
//   };

//   const handlePageChange = (page, e) => {
//     if (e) e.stopPropagation();
//     if (page >= 1 && page <= totalPages) {
//       setCurrentPage(page);
//     }
//   };

//   const handleInputFocus = () => {
//     if (!isDisabled) {
//       setIsActive(true);
//     }
//   };

//   const handleSearchChange = (e) => {
//     const value = e.target.value;
//     setSearchTerm(value);
//     if (!isActive) setIsActive(true);

//     if (onSearchInputChange) {
//       onSearchInputChange(value); // Call the parent to fetch options (if server-side)
//     }
//   };

//   const handleInputClick = () => {
//     if (!isDisabled) {
//       setIsActive(true);
//     }
//   };

//   // pagination rendering (kept your implementation)
//   const renderPagination = () => {
//     const pages = [];

//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(i);
//       }
//     } else {
//       if (currentPage <= 3) {
//         pages.push(1, 2, 3, "dots", totalPages);
//       } else if (currentPage > 3 && currentPage < totalPages - 2) {
//         pages.push(1, "dots", currentPage - 1, currentPage, currentPage + 1, "dots", totalPages);
//       } else {
//         pages.push(1, "dots", totalPages - 2, totalPages - 1, totalPages);
//       }
//     }

//     return pages.map((p, idx) => {
//       if (p === "dots") return (
//         <span key={`dots-${idx}`} style={{ padding: "5px", fontSize: "12px", color: "#666" }}>...</span>
//       );
//       return (
//         <button
//           key={p}
//           onClick={(e) => handlePageChange(p, e)}
//           style={{
//             padding: "5px 10px",
//             margin: "0 2px",
//             border: "1px solid #ccc",
//             borderRadius: "5px",
//             backgroundColor: p === currentPage ? Colors.color1 : "#fff",
//             color: p === currentPage ? "#fff" : "#000",
//             cursor: "pointer",
//             fontSize: "12px",
//           }}
//         >
//           {p}
//         </button>
//       );
//     });
//   };

//   return (
//     <div
//       className={`dropdown-CB ${className || ""}`}
//       style={{
//         width,
//         ...style,
//         pointerEvents: isDisabled ? "none" : "auto",
//         opacity: isDisabled ? 0.7 : 1,
//       }}
//       ref={dropdownRef}
//     >
//       <label className="dropdown-CB-label">
//         {label}
//         {isRequired && <span>*</span>}
//       </label>

//       <div style={{ position: "relative", marginTop: "8px" }}>
//         <input
//           ref={searchInputRef}
//           type="text"
//           placeholder={selectedLabel || "Search or select student..."}
//           value={isActive ? searchTerm : selectedLabel}
//           onChange={handleSearchChange}
//           onFocus={handleInputFocus}
//           onClick={handleInputClick}
//           disabled={isDisabled}
//           style={{
//             width: "100%",
//             padding: "8px",
//             border: "1px solid gray",
//             fontSize: "14px",
//             outline: "none",
//             boxSizing: "border-box",
//             cursor: isDisabled ? "not-allowed" : "text",
//             backgroundColor: isDisabled ? "transparent" : Colors.color14,
//             color: "rgb(106, 106, 106)",
//           }}
//         />
//         <img
//           src={DropDownIcon}
//           alt="dropdown-icon"
//           style={{
//             position: "absolute",
//             right: "12px",
//             top: "50%",
//             transform: "translateY(-50%)",
//             pointerEvents: "none",
//             width: "28px",
//             height: "20px",
//           }}
//         />
//       </div>

//       {isActive && (
//         <div
//           className="dropdown-content-CBV2"
//           style={{
//             width: customWidth || "100%",
//             top: customTop || "100%",
//             marginTop: "4px",
//             maxHeight: "300px",
//           }}
//         >
//           {/* NEW: Select All row (operates on full `options` client-side) */}
//           {showSelectAll && (
//             <div style={{ padding: "8px 12px", borderBottom: "1px solid #eee", display: "flex", alignItems: "center" }}>
//               <input
//                 type="checkbox"
//                 checked={isAllSelected}
//                 onChange={handleSelectAll}
//                 style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
//                 disabled={isDisabled}
//                 className="delete-question-checkbox-dqc"
//               />
//               <label
//                 style={{ marginLeft: "8px", cursor: isDisabled ? "not-allowed" : "pointer" }}
//                 onClick={() => { if (!isDisabled) handleSelectAll(); }}
//               >
//                 Select All
//               </label>
//             </div>
//           )}

//           <div style={{ maxHeight: "200px", overflowY: "auto" }}>
//             {currentOptions.length > 0 ? (
//               currentOptions.map((option) => (
//                 <div
//                   key={option.id}
//                   className="dropdown-item-CBV2"
//                   onClick={() => handleClick(option)}
//                   style={{ display: "flex", alignItems: "center", padding: "12px", cursor: "pointer" }}
//                 >
//                   {/* show checkbox to indicate multi-select */}
//                   <input
//                     type="checkbox"
//                     checked={safeSelected.includes(option.id)}
//                     readOnly
//                     style={{ marginRight: 8, cursor: "pointer" }}
//                     className="delete-question-checkbox-dqc"
//                   />
//                   <div>{option.label}</div>
//                 </div>
//               ))
//             ) : (
//               <div
//                 style={{
//                   padding: "20px",
//                   textAlign: "center",
//                   color: "#999",
//                   fontSize: "14px",
//                 }}
//               >
//                 No results found
//               </div>
//             )}
//           </div>

//           {/* Pagination */}
//           {totalPages > 1 && currentOptions.length > 0 && (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "end",
//                 alignItems: "center",
//                 padding: "10px",
//                 borderTop: "1px solid #e0e0e0",
//                 backgroundColor: "#f9f9f9",
//                 gap: "5px",
//               }}
//             >
//               <button
//                 onClick={(e) => handlePageChange(1, e)}
//                 disabled={currentPage === 1}
//                 style={{
//                   padding: "5px 8px",
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   backgroundColor: currentPage === 1 ? "#f0f0f0" : "#fff",
//                   cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                   fontSize: "12px",
//                 }}
//               >
//                 «
//               </button>

//               <button
//                 onClick={(e) => handlePageChange(currentPage - 1, e)}
//                 disabled={currentPage === 1}
//                 style={{
//                   padding: "5px 8px",
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   backgroundColor: currentPage === 1 ? "#f0f0f0" : "#fff",
//                   cursor: currentPage === 1 ? "not-allowed" : "pointer",
//                   fontSize: "12px",
//                 }}
//               >
//                 ‹
//               </button>

//               {renderPagination()}

//               <button
//                 onClick={(e) => handlePageChange(currentPage + 1, e)}
//                 disabled={currentPage === totalPages}
//                 style={{
//                   padding: "5px 8px",
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   backgroundColor:
//                     currentPage === totalPages ? "#f0f0f0" : "#fff",
//                   cursor:
//                     currentPage === totalPages ? "not-allowed" : "pointer",
//                   fontSize: "12px",
//                 }}
//               >
//                 ›
//               </button>

//               <button
//                 onClick={(e) => handlePageChange(totalPages, e)}
//                 disabled={currentPage === totalPages}
//                 style={{
//                   padding: "5px 8px",
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   backgroundColor:
//                     currentPage === totalPages ? "#f0f0f0" : "#fff",
//                   cursor:
//                     currentPage === totalPages ? "not-allowed" : "pointer",
//                   fontSize: "12px",
//                 }}
//               >
//                 »
//               </button>
//             </div>
//           )}

//           {searchTerm && (
//             <div
//               style={{
//                 padding: "5px 10px",
//                 textAlign: "center",
//                 fontSize: "11px",
//                 color: "#666",
//                 backgroundColor: "#f9f9f9",
//                 borderTop: "1px solid #e0e0e0",
//               }}
//             >
//               {filteredOptions.length} result
//               {filteredOptions.length !== 1 ? "s" : ""} found
//             </div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }























// // import React, { useState, useRef, useEffect } from "react";
// // import DropDownIcon from "../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
// // import Colors from "../../Constants/Colors";

// // export default function DropdownWithPagination({
// //   width,
// //   label,
// //   selected,
// //   setSelected,
// //   options,
// //   customWidth,
// //   customTop,
// //   isRequired,
// //   style,
// //   className,
// //   isDisabled = false,
// //   itemsPerPage = 5,
// //   onSearchInputChange,
// // }) {
// //   const [isActive, setIsActive] = useState(false);
// //   const [selectedLabel, setSelectedLabel] = useState("");
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [searchTerm, setSearchTerm] = useState("");
// //   const dropdownRef = useRef(null);
// //   const searchInputRef = useRef(null);

// //   useEffect(() => {
// //     function handleClickOutside(event) {
// //       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
// //         setIsActive(false);
// //       }
// //     }
// //     document.addEventListener("mousedown", handleClickOutside);
// //     return () => {
// //       document.removeEventListener("mousedown", handleClickOutside);
// //     };
// //   }, []);

// //   useEffect(() => {
// //     if (selected && Array.isArray(options)) {
// //       const found = options.find((option) => option.id === selected);
// //       if (found) {
// //         setSelectedLabel(found.label);
// //       } else {
// //         setSelectedLabel("");
// //       }
// //     }
// //   }, [selected, options]);

// //   const filteredOptions =
// //     options?.filter((option) =>
// //       option.label.toLowerCase().includes(searchTerm.toLowerCase())
// //     ) || [];

// //   const totalPages = Math.ceil(filteredOptions.length / itemsPerPage);
// //   const startIndex = (currentPage - 1) * itemsPerPage;
// //   const endIndex = startIndex + itemsPerPage;
// //   const currentOptions = filteredOptions.slice(startIndex, endIndex);

// //   useEffect(() => {
// //     setCurrentPage(1);
// //   }, [searchTerm]);

// //   const handleClick = (option) => {
// //     if (isDisabled) return;
// //     setSelected(option.id);
// //     setIsActive(false);
// //     setSelectedLabel(option.label);
// //     setSearchTerm("");
// //   };

// //   const handlePageChange = (page, e) => {
// //     if (e) e.stopPropagation();
// //     if (page >= 1 && page <= totalPages) {
// //       setCurrentPage(page);
// //     }
// //   };

// //   const handleInputFocus = () => {
// //     if (!isDisabled) {
// //       setIsActive(true);
// //     }
// //   };

// //   const handleSearchChange = (e) => {
// //     const value = e.target.value;
// //     setSearchTerm(value);
// //     if (!isActive) setIsActive(true);

// //     if (onSearchInputChange) {
// //         onSearchInputChange(value); // Call the parent function to fetch options
// //     }
// //     };


// //   const handleInputClick = () => {
// //     if (!isDisabled) {
// //       setIsActive(true);
// //     }
// //   };

// //   // ✅ Advanced pagination rendering
// //   const renderPagination = () => {
// //     const pages = [];

// //     if (totalPages <= 5) {
// //       for (let i = 1; i <= totalPages; i++) {
// //         pages.push(
// //           <button
// //             key={i}
// //             onClick={(e) => handlePageChange(i, e)}
// //             style={{
// //               padding: "5px 10px",
// //               margin: "0 2px",
// //               border: "1px solid #ccc",
// //               borderRadius: "5px",
// //               backgroundColor: i === currentPage ? Colors.color1 : "#fff",
// //               color: i === currentPage ? "#fff" : "#000",
// //               cursor: "pointer",
// //               fontSize: "12px",
// //             }}
// //           >
// //             {i}
// //           </button>
// //         );
// //       }
// //     } else {
// //       if (currentPage <= 3) {
// //         for (let i = 1; i <= 3; i++) {
// //           pages.push(
// //             <button
// //               key={i}
// //               onClick={(e) => handlePageChange(i, e)}
// //               style={{
// //                 padding: "5px 10px",
// //                 margin: "0 2px",
// //                 border: "1px solid #ccc",
// //                 borderRadius: "5px",
// //                 backgroundColor: i === currentPage ? Colors.color1 : "#fff",
// //                 color: i === currentPage ? "#fff" : "#000",
// //                 cursor: "pointer",
// //                 fontSize: "12px",
// //               }}
// //             >
// //               {i}
// //             </button>
// //           );
// //         }
// //         pages.push(
// //           <span
// //             key="dots1"
// //             style={{ padding: "5px", fontSize: "12px", color: "#666" }}
// //           >
// //             ...
// //           </span>
// //         );
// //         pages.push(
// //           <button
// //             key={totalPages}
// //             onClick={(e) => handlePageChange(totalPages, e)}
// //             style={{
// //               padding: "5px 10px",
// //               margin: "0 2px",
// //               border: "1px solid #ccc",
// //               borderRadius: "5px",
// //               backgroundColor: "#fff",
// //               color: "#000",
// //               cursor: "pointer",
// //               fontSize: "12px",
// //             }}
// //           >
// //             {totalPages}
// //           </button>
// //         );
// //       } else if (currentPage > 3 && currentPage < totalPages - 2) {
// //         pages.push(
// //           <button
// //             key={1}
// //             onClick={(e) => handlePageChange(1, e)}
// //             style={{
// //               padding: "5px 10px",
// //               margin: "0 2px",
// //               border: "1px solid #ccc",
// //               borderRadius: "5px",
// //               backgroundColor: "#fff",
// //               color: "#000",
// //               cursor: "pointer",
// //               fontSize: "12px",
// //             }}
// //           >
// //             1
// //           </button>
// //         );
// //         pages.push(
// //           <span
// //             key="dots1"
// //             style={{ padding: "5px", fontSize: "12px", color: "#666" }}
// //           >
// //             ...
// //           </span>
// //         );
// //         for (let i = currentPage - 1; i <= currentPage + 1; i++) {
// //           pages.push(
// //             <button
// //               key={i}
// //               onClick={(e) => handlePageChange(i, e)}
// //               style={{
// //                 padding: "5px 10px",
// //                 margin: "0 2px",
// //                 border: "1px solid #ccc",
// //                 borderRadius: "5px",
// //                 backgroundColor: i === currentPage ? Colors.color1 : "#fff",
// //                 color: i === currentPage ? "#fff" : "#000",
// //                 cursor: "pointer",
// //                 fontSize: "12px",
// //               }}
// //             >
// //               {i}
// //             </button>
// //           );
// //         }
// //         pages.push(
// //           <span
// //             key="dots2"
// //             style={{ padding: "5px", fontSize: "12px", color: "#666" }}
// //           >
// //             ...
// //           </span>
// //         );
// //         pages.push(
// //           <button
// //             key={totalPages}
// //             onClick={(e) => handlePageChange(totalPages, e)}
// //             style={{
// //               padding: "5px 10px",
// //               margin: "0 2px",
// //               border: "1px solid #ccc",
// //               borderRadius: "5px",
// //               backgroundColor: "#fff",
// //               color: "#000",
// //               cursor: "pointer",
// //               fontSize: "12px",
// //             }}
// //           >
// //             {totalPages}
// //           </button>
// //         );
// //       } else {
// //         pages.push(
// //           <button
// //             key={1}
// //             onClick={(e) => handlePageChange(1, e)}
// //             style={{
// //               padding: "5px 10px",
// //               margin: "0 2px",
// //               border: "1px solid #ccc",
// //               borderRadius: "5px",
// //               backgroundColor: "#fff",
// //               color: "#000",
// //               cursor: "pointer",
// //               fontSize: "12px",
// //             }}
// //           >
// //             1
// //           </button>
// //         );
// //         pages.push(
// //           <span
// //             key="dots1"
// //             style={{ padding: "5px", fontSize: "12px", color: "#666" }}
// //           >
// //             ...
// //           </span>
// //         );
// //         for (let i = totalPages - 2; i <= totalPages; i++) {
// //           pages.push(
// //             <button
// //               key={i}
// //               onClick={(e) => handlePageChange(i, e)}
// //               style={{
// //                 padding: "5px 10px",
// //                 margin: "0 2px",
// //                 border: "1px solid #ccc",
// //                 borderRadius: "5px",
// //                 backgroundColor: i === currentPage ? Colors.color1 : "#fff",
// //                 color: i === currentPage ? "#fff" : "#000",
// //                 cursor: "pointer",
// //                 fontSize: "12px",
// //               }}
// //             >
// //               {i}
// //             </button>
// //           );
// //         }
// //       }
// //     }
// //     return pages;
// //   };

// //   return (
// //     <div
// //       className={`dropdown-CB ${className || ""}`}
// //       style={{
// //         width,
// //         ...style,
// //         pointerEvents: isDisabled ? "none" : "auto",
// //         opacity: isDisabled ? 0.7 : 1,
// //       }}
// //       ref={dropdownRef}
// //     >
// //       <label className="dropdown-CB-label">
// //         {label}
// //         {isRequired && <span>*</span>}
// //       </label>

// //       <div style={{ position: "relative", marginTop: "8px" }}>
// //         <input
// //           ref={searchInputRef}
// //           type="text"
// //           placeholder={selectedLabel || "Search or select student..."}
// //           value={isActive ? searchTerm : selectedLabel}
// //           onChange={handleSearchChange}
// //           onFocus={handleInputFocus}
// //           onClick={handleInputClick}
// //           disabled={isDisabled}
// //           style={{
// //             width: "100%",
// //             padding: "8px",
// //             border: "1px solid gray",
// //             fontSize: "14px",
// //             outline: "none",
// //             boxSizing: "border-box",
// //             cursor: isDisabled ? "not-allowed" : "text",
// //             backgroundColor: isDisabled ? "transparent" : Colors.color14,
// //             color: "rgb(106, 106, 106)",
// //           }}
// //         />
// //         <img
// //           src={DropDownIcon}
// //           alt="dropdown-icon"
// //           style={{
// //             position: "absolute",
// //             right: "12px",
// //             top: "50%",
// //             transform: "translateY(-50%)",
// //             pointerEvents: "none",
// //             width: "28px",
// //             height: "20px",
// //           }}
// //         />
// //       </div>

// //       {isActive && (
// //         <div
// //           className="dropdown-content-CBV2"
// //           style={{
// //             width: customWidth || "100%",
// //             top: customTop || "100%",
// //             marginTop: "4px",
// //             maxHeight: "300px",
// //           }}
// //         >
// //           <div style={{ maxHeight: "200px", overflowY: "auto" }}>
// //             {currentOptions.length > 0 ? (
// //               currentOptions.map((option) => (
// //                 <div
// //                   key={option.id}
// //                   className="dropdown-item-CBV2"
// //                   onClick={() => handleClick(option)}
// //                 >
// //                   {option.label}
// //                 </div>
// //               ))
// //             ) : (
// //               <div
// //                 style={{
// //                   padding: "20px",
// //                   textAlign: "center",
// //                   color: "#999",
// //                   fontSize: "14px",
// //                 }}
// //               >
// //                 No results found
// //               </div>
// //             )}
// //           </div>

// //           {/* ✅ Advanced pagination */}
// //           {totalPages > 1 && currentOptions.length > 0 && (
// //             <div
// //               style={{
// //                 display: "flex",
// //                 justifyContent: "end",
// //                 alignItems: "center",
// //                 padding: "10px",
// //                 borderTop: "1px solid #e0e0e0",
// //                 backgroundColor: "#f9f9f9",
// //                 gap: "5px",
// //               }}
// //             >
// //               <button
// //                 onClick={(e) => handlePageChange(1, e)}
// //                 disabled={currentPage === 1}
// //                 style={{
// //                   padding: "5px 8px",
// //                   border: "1px solid #ccc",
// //                   borderRadius: "5px",
// //                   backgroundColor: currentPage === 1 ? "#f0f0f0" : "#fff",
// //                   cursor: currentPage === 1 ? "not-allowed" : "pointer",
// //                   fontSize: "12px",
// //                 }}
// //               >
// //                 «
// //               </button>

// //               <button
// //                 onClick={(e) => handlePageChange(currentPage - 1, e)}
// //                 disabled={currentPage === 1}
// //                 style={{
// //                   padding: "5px 8px",
// //                   border: "1px solid #ccc",
// //                   borderRadius: "5px",
// //                   backgroundColor: currentPage === 1 ? "#f0f0f0" : "#fff",
// //                   cursor: currentPage === 1 ? "not-allowed" : "pointer",
// //                   fontSize: "12px",
// //                 }}
// //               >
// //                 ‹
// //               </button>

// //               {renderPagination()}

// //               <button
// //                 onClick={(e) => handlePageChange(currentPage + 1, e)}
// //                 disabled={currentPage === totalPages}
// //                 style={{
// //                   padding: "5px 8px",
// //                   border: "1px solid #ccc",
// //                   borderRadius: "5px",
// //                   backgroundColor:
// //                     currentPage === totalPages ? "#f0f0f0" : "#fff",
// //                   cursor:
// //                     currentPage === totalPages ? "not-allowed" : "pointer",
// //                   fontSize: "12px",
// //                 }}
// //               >
// //                 ›
// //               </button>

// //               <button
// //                 onClick={(e) => handlePageChange(totalPages, e)}
// //                 disabled={currentPage === totalPages}
// //                 style={{
// //                   padding: "5px 8px",
// //                   border: "1px solid #ccc",
// //                   borderRadius: "5px",
// //                   backgroundColor:
// //                     currentPage === totalPages ? "#f0f0f0" : "#fff",
// //                   cursor:
// //                     currentPage === totalPages ? "not-allowed" : "pointer",
// //                   fontSize: "12px",
// //                 }}
// //               >
// //                 »
// //               </button>
// //             </div>
// //           )}

// //           {searchTerm && (
// //             <div
// //               style={{
// //                 padding: "5px 10px",
// //                 textAlign: "center",
// //                 fontSize: "11px",
// //                 color: "#666",
// //                 backgroundColor: "#f9f9f9",
// //                 borderTop: "1px solid #e0e0e0",
// //               }}
// //             >
// //               {filteredOptions.length} result
// //               {filteredOptions.length !== 1 ? "s" : ""} found
// //             </div>
// //           )}
// //         </div>
// //       )}
// //     </div>
// //   );
// // }









// PAGINATION WITH MULTI-SELECT SUPPORT AND SIGNIFICANT IMPROVEMENTS
import React, { useState, useRef, useEffect, useMemo } from "react";
import DropDownIcon from "../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
import Colors from "../../Constants/Colors";


export default function DropdownWithPagination({
  width,
  label,
  selected = [],
  setSelected,
  options = [],
  customWidth,
  customTop,
  isRequired,
  style,
  className,
  isDisabled = false,
  itemsPerPage = 5,
  onSearchInputChange,
  showSelectAll = false,
  allowMultiple = true,
  placeholder = "Search or select...",
  showLabelCheckbox = false,
  labelCheckboxChecked = false,
  onLabelCheckboxChange,
  labelCheckboxText,

}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  // normalize selected array
  const safeSelected = Array.isArray(selected) ? selected : [];

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // 🔥 Clear searchTerm automatically when selection changes
  useEffect(() => {
    setSearchTerm("");
  }, [selected]);


  // selected label display
  useEffect(() => {
    if (safeSelected.length > 0 && Array.isArray(options)) {
      const labels = options
        .filter((o) => safeSelected.includes(o.id))
        .map((o) => o.label);

      const fullText = labels.join(", ");
      const maxLength = 75;

      if (fullText.length > maxLength) {
        setSelectedLabel(fullText.slice(0, maxLength) + "...");
      } else {
        setSelectedLabel(fullText);
      }
    } else {
      setSelectedLabel("");
    }
  }, [safeSelected, options]);

  // Filtering logic
  const filteredOptions = useMemo(() => {
    if (!Array.isArray(options)) return [];
    if (onSearchInputChange) return options; // server-side mode
    if (!searchTerm) return options;
    const q = searchTerm.toLowerCase();
    return options.filter((option) =>
      (option.label || "").toString().toLowerCase().includes(q)
    );
  }, [options, searchTerm, onSearchInputChange]);

  const totalPages = Math.max(1, Math.ceil(filteredOptions.length / itemsPerPage));
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentOptions = filteredOptions.slice(startIndex, endIndex);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // ✅ handle single / multiple selection
  const handleToggleOption = (option) => {
    if (isDisabled) return;
    const id = option.id;

    if (allowMultiple) {
      // multi-select
      if (safeSelected.includes(id)) {
        setSelected(safeSelected.filter((sid) => sid !== id));
      } else {
        setSelected([...safeSelected, id]);
      }
    } else {
      // single-select
      if (safeSelected.includes(id)) {
        setSelected([]);
      } else {
        setSelected([id]);
      }
      setIsActive(false); // close dropdown after one selection
    }
  };

  // Select All logic (multi-select only)
  const allOptionIds = useMemo(
    () => (Array.isArray(options) ? options.map((o) => o.id) : []),
    [options]
  );
  const isAllSelected =
    allOptionIds.length > 0 &&
    allOptionIds.every((id) => safeSelected.includes(id));

  const handleSelectAll = () => {
    if (isDisabled) return;
    if (isAllSelected) {
      setSelected([]);
    } else {
      setSelected(allOptionIds);
    }
  };

  const handleClick = (option) => {
    handleToggleOption(option);
  };

  const handlePageChange = (page, e) => {
    if (e) e.stopPropagation();
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleInputFocus = () => {
    if (!isDisabled) {
      setIsActive(true);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (!isActive) setIsActive(true);
    if (onSearchInputChange) {
      onSearchInputChange(value); // fetch server-side options
    }
  };

  const handleInputClick = () => {
    if (!isDisabled) {
      setIsActive(true);
    }
  };

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "dots", totalPages);
      } else if (currentPage > 3 && currentPage < totalPages - 2) {
        pages.push(1, "dots", currentPage - 1, currentPage, currentPage + 1, "dots", totalPages);
      } else {
        pages.push(1, "dots", totalPages - 2, totalPages - 1, totalPages);
      }
    }

    return pages.map((p, idx) => {
      if (p === "dots")
        return (
          <span key={`dots-${idx}`} style={{ padding: "5px", fontSize: "12px", color: "#666" }}>
            ...
          </span>
        );
      return (
        <button
          key={p}
          onClick={(e) => handlePageChange(p, e)}
          style={{
            padding: "5px 10px",
            margin: "0 2px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            backgroundColor: p === currentPage ? Colors.color1 : "#fff",
            color: p === currentPage ? "#fff" : "#000",
            cursor: "pointer",
            fontSize: "12px",
          }}
        >
          {p}
        </button>
      );
    });
  };

  return (
    <div
      className={`dropdown-CB ${className || ""}`}
      style={{
        width,
        ...style,
        pointerEvents: isDisabled ? "none" : "auto",
        opacity: isDisabled ? 0.7 : 1,
      }}
      ref={dropdownRef}
    >
      {/* <label className="dropdown-CB-label">
        {label}
        {isRequired && <span>*</span>}
      </label> */}

      <div className="dropdown-CB-label" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <label className="dropdown-CB-label">
              {label}
              {isRequired && <span>*</span>}
            </label>

        {showLabelCheckbox && (
          <div style={{ display: "flex", alignItems: "center"}}>
            <input
              type="checkbox"
              className="delete-question-checkbox-dqc"
              checked={labelCheckboxChecked}
              onChange={(e) => onLabelCheckboxChange?.(e.target.checked)}
            />
            {labelCheckboxText && (
              <span style={{ fontSize: "14px", color: "#6A6A6A" }}>{labelCheckboxText}</span>
            )}
          </div>
      )}
      </div>


      <div style={{ position: "relative", marginTop: "6px" }}>
        <input
          ref={searchInputRef}
          type="text"
          // placeholder={selectedLabel || "Search or select..."}
          // placeholder={selectedLabel || placeholder}
          placeholder={placeholder}
          // value={isActive ? searchTerm : selectedLabel}
          value={isActive ? searchTerm : ""}
          onChange={handleSearchChange}
          onFocus={handleInputFocus}
          onClick={handleInputClick}
          disabled={isDisabled}
          style={{
            width: "100%",
            padding: "8px",
            border: "1px solid gray",
            fontSize: "14px",
            outline: "none",
            boxSizing: "border-box",
            cursor: isDisabled ? "not-allowed" : "text",
            backgroundColor: isDisabled ? "transparent" : Colors.color14,
            color: "rgb(106, 106, 106)",
          }}
        />
        <img
          src={DropDownIcon}
          alt="dropdown-icon"
          style={{
            position: "absolute",
            right: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            width: "28px",
            height: "20px",
          }}
        />
      </div>

      {isActive && (
        <div
          className="dropdown-content-CBV2"
          style={{
            width: customWidth || "100%",
            top: customTop || "100%",
            marginTop: "4px",
            maxHeight: "300px",
          }}
        >
          {/* ✅ Select All only in multi-select mode */}
          {showSelectAll && allowMultiple && (
            <div
              style={{
                padding: "8px 12px",
                borderBottom: "1px solid #eee",
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={handleSelectAll}
                style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
                disabled={isDisabled}
                className="delete-question-checkbox-dqc"
              />
              <label
                style={{ marginLeft: "8px", cursor: isDisabled ? "not-allowed" : "pointer" }}
                onClick={() => {
                  if (!isDisabled) handleSelectAll();
                }}
              >
                Select All
              </label>
            </div>
          )}

          <div style={{ maxHeight: "200px", overflowY: "auto" }}>
            {currentOptions.length > 0 ? (
              currentOptions.map((option) => (
                <div
                  key={option.id}
                  className="dropdown-item-CBV2"
                  onClick={() => handleClick(option)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "12px",
                    cursor: "pointer",
                  }}
                >
                  {/* ✅ Hide checkboxes for single-select mode */}
                  {/* {(showSelectAll || allowMultiple) && (
                    <input
                      type="checkbox"
                      checked={safeSelected.includes(option.id)}
                      readOnly
                      style={{ marginRight: 8, cursor: "pointer" }}
                      className="delete-question-checkbox-dqc"
                    />
                  )} */}
                  {(showSelectAll || allowMultiple) && (
                    <label
                      className="CK-custom-checkbox-container"
                      style={{
                        position: "relative",
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                        flexShrink: 0,
                        marginRight: "8px",
                      }}
                      onClick={(e) => e.stopPropagation()}   // Prevent parent click
                    >
                      <input
                        type="checkbox"
                        checked={safeSelected.includes(option.id)}
                        onChange={(e) => {
                          e.stopPropagation();
                          handleToggleOption(option);
                        }}
                        style={{ cursor: "pointer" }}
                      />
                      <span className="CK-custom-checkmark"></span>
                    </label>
                  )}
                  <div>{option.label}</div>
                </div>
              ))
            ) : (
              <div
                style={{
                  padding: "20px",
                  textAlign: "center",
                  color: "#999",
                  fontSize: "14px",
                }}
              >
                No results found
              </div>
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && currentOptions.length > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                padding: "10px",
                borderTop: "1px solid #e0e0e0",
                backgroundColor: "#f9f9f9",
                gap: "5px",
              }}
            >
              <button
                onClick={(e) => handlePageChange(1, e)}
                disabled={currentPage === 1}
                style={{
                  padding: "5px 8px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  backgroundColor: currentPage === 1 ? "#f0f0f0" : "#fff",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  fontSize: "12px",
                }}
              >
                «
              </button>

              <button
                onClick={(e) => handlePageChange(currentPage - 1, e)}
                disabled={currentPage === 1}
                style={{
                  padding: "5px 8px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  backgroundColor: currentPage === 1 ? "#f0f0f0" : "#fff",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  fontSize: "12px",
                }}
              >
                ‹
              </button>

              {renderPagination()}

              <button
                onClick={(e) => handlePageChange(currentPage + 1, e)}
                disabled={currentPage === totalPages}
                style={{
                  padding: "5px 8px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  backgroundColor:
                    currentPage === totalPages ? "#f0f0f0" : "#fff",
                  cursor:
                    currentPage === totalPages ? "not-allowed" : "pointer",
                  fontSize: "12px",
                }}
              >
                ›
              </button>

              <button
                onClick={(e) => handlePageChange(totalPages, e)}
                disabled={currentPage === totalPages}
                style={{
                  padding: "5px 8px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  backgroundColor:
                    currentPage === totalPages ? "#f0f0f0" : "#fff",
                  cursor:
                    currentPage === totalPages ? "not-allowed" : "pointer",
                  fontSize: "12px",
                }}
              >
                »
              </button>
            </div>
          )}

          {searchTerm && (
            <div
              style={{
                padding: "5px 10px",
                textAlign: "center",
                fontSize: "11px",
                color: "#666",
                backgroundColor: "#f9f9f9",
                borderTop: "1px solid #e0e0e0",
              }}
            >
              {filteredOptions.length} result
              {filteredOptions.length !== 1 ? "s" : ""} found
            </div>
          )}
        </div>
      )}
    </div>
  );
}
